import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3da7c8d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "VideoPlayer", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Videos:", -1))
const _hoisted_3 = { class: "videos" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]

import { ref, nextTick, computed, onMounted, watch } from 'vue';
import * as rac from '@primafuture/remote-async-call';
import ReconnectingWebSocket from 'reconnecting-websocket';
import * as config from '@/config';



export const EmitsOptions = {
	'onPlaybackSessionReady' : (playbackSessionId: string|null) => {return true;},
}

export default /*#__PURE__*/_defineComponent({
  __name: 'VideoPlayer',
  emits: EmitsOptions,
  setup(__props, { emit }) {


const videos = {
	'HTML Seznamy': {
		recordingSessionId: 'b13a3695-1b2e-4c0e-99d2-1c032fbd11bb',
		bookmarks: [[0, 24], [0, 32], ],
	},
	'Font Awesome - ikony': {
		recordingSessionId: '6c994bf4-8cf6-4f08-b585-3009d92d3ff5',
		bookmarks: [[3, 30]],
	},
	'HTML PrimaKavárna - Footer - patička': {
		recordingSessionId: '3e857c45-b12f-4ba1-ae0d-b06ebc7f9f9e',
		bookmarks: [],
	},
	'PrimaKavárna File Manager': {
		recordingSessionId: '771197a7-87b3-4fa7-a377-54be87c2c3f9',
		bookmarks: [[3, 41], [6, 36], ],
	},
	'JS PrimaKavárna': {
		recordingSessionId: '38b250a6-6003-4b08-8564-6d3b92fb063f',
		bookmarks: [[4, 23], [6, 4], [6, 55], [7, 28], ],
	},
	'xdebug - Windows': {
		recordingSessionId: '32ded006-306b-452f-901e-baf58ad96e03',
		bookmarks: [],
	},
	'xdebug - Apple Mac OS': {
		recordingSessionId: '68d21294-fe86-4fe6-85b4-9ede01fa0314',
		bookmarks: [],
	},
	'Závěrečné slovo a diskuze': {
		recordingSessionId: '4e32f23e-67b9-4556-a25e-e6a7ad14b673',
		bookmarks: [],
	},
};




// konfigurace app
const appConfig = ref<config.IAppConfig|null>(null);
onMounted(async () => {
	appConfig.value = await config.loadConfig();
});


const playbackSessionId = ref<string|null>(null);


watch(appConfig, () => {
	if (!appConfig.value) {
		return;
	}

	const backendWebSocketConnection = new ReconnectingWebSocket(appConfig.value.api.websocketUrl, [], {
		maxReconnectionDelay: 2000,
		minReconnectionDelay: 1000,
		debug: false,
	});
	racProxy = new rac.RACProxy(new rac.WebsocketCommunicationConnection(backendWebSocketConnection));
	racProxy.onConnected(() => {
		console.log('Backend communication broker connected');

		racProxy.subscribe('setPlaybackState', async (args:any) => {
			const [newPlaybackState] = args;
			//console.log('setPlaybackState', newPlaybackState);
			if (elVideo.value) {
				if (newPlaybackState.playbackState == 'pause') {
					elVideo.value.pause();
				}else if (newPlaybackState.playbackState == 'play') {
					elVideo.value.play();
				}
			}
		});

		racProxy.onRemoteProcedureRegistered('ready', async () => {
			const playbackSessionResult = await racProxyCall('createPlaybackSession', []);
			//console.log({playbackSessionResult});

			playbackSessionId.value = playbackSessionResult.playbackSession.id;

			emit('onPlaybackSessionReady', playbackSessionId.value);

			const role = 'video-player';
			const connectResult = await racProxyCall('connect', [playbackSessionId.value, role]);
			//console.log({connectResult});

			// zvolit aktualni video
			if (selectedVideoRecordingSessionId.value) {
				const selectVideoResult = await racProxyCall('selectVideo', ['kurz-programator', selectedVideoRecordingSessionId.value]);
				//console.log({selectVideoResult});

				if (elVideo.value) {
					sendPlaybackState(!elVideo.value.paused ? 'playing' : 'pause');
				}
			}
		});
	});	
});

let racProxy:any = null;


async function racProxyCall(methodName:string, ...args:any[]) {
	let result;
	try {
		result = await racProxy.call(methodName, ...args);
	}catch (err) {
		console.error("RAC Proxy Call failed", {methodName, args, err});
		console.error(err);
		console.error((err as Error).stack);
		alert("Interní chyba systému");
	}
	return result;
}

const selectedVideoRecordingSessionId = ref<string|null>(null);
const elSelectedVideoRecordingSessionId = ref<HTMLInputElement|null>(null);

function selectInputVideoRecordingSessionIdText() {
	if (elSelectedVideoRecordingSessionId.value) {
		elSelectedVideoRecordingSessionId.value.select();
	}
}

const selectedVideoUrl = computed(() => {
	return `http://vs-misc-focal:4000/=/media/piksla-video/primakurzyonline.cz/kurz-programator/pko-render/videos/${selectedVideoRecordingSessionId.value}/05-crop-meta-info/${selectedVideoRecordingSessionId.value}.mkv`;
});

const elVideo = ref<HTMLMediaElement|null>(null);

async function selectVideo(videoRecordingSessionId:string) {
	selectedVideoRecordingSessionId.value = videoRecordingSessionId;
}
watch(selectedVideoRecordingSessionId, async () => {
	if (selectedVideoRecordingSessionId.value) {
		selectInputVideoRecordingSessionIdText();
		
		nextTick(() => {
			if (elVideo.value) {
				elVideo.value.play();
			}
		});

		const selectVideoResult = await racProxyCall('selectVideo', ['kurz-programator', selectedVideoRecordingSessionId.value]);
		//console.log({selectVideoResult});
	}
});

function getPlaybackState() {
	if (!elVideo.value) {
		return null;
	}

	return {
		playing: elVideo.value.currentTime > 0 && !elVideo.value.paused && !elVideo.value.ended && elVideo.value.readyState >= elVideo.value.HAVE_CURRENT_DATA,
		currentTime: elVideo.value.currentTime,
		playbackRate: elVideo.value.playbackRate,
	};
}

async function sendPlaybackState(state:string) {
	//console.log("sendPlaybackState", {state});
	const playbackState = getPlaybackState();

	if (playbackState !== null) {
		racProxy.publish('playbackStateChanged', [state, playbackState]);
	}
}

async function onVideoPlay() {
	sendPlaybackState('play')
}

async function onVideoPlaying() {
	sendPlaybackState('playing')
}

async function onVideoPause() {
	sendPlaybackState('pause')
}

async function onVideoEnded() {
	sendPlaybackState('ended')
}

async function onVideoRateChange() {
	sendPlaybackState('playbackRateChanged')
}

async function onVideoSeeked() {
	sendPlaybackState('seeked')
}

async function onVideoWaiting() {
	sendPlaybackState('waiting')
}

function seekTo(recordingSessionId:string, bookmark:Array<number>) {
	if (selectedVideoRecordingSessionId.value != recordingSessionId) {
		selectVideo(recordingSessionId);
	}
	setTimeout(() => {
		if (elVideo.value) {
			elVideo.value.currentTime = bookmark[0] * 60 + bookmark[1];
			elVideo.value.play();
		}
	}, 500);
}

function syncPlaybackState() {
	if (selectedVideoRecordingSessionId.value) {
		const playbackState = getPlaybackState();
		if (!playbackState) {
			return;
		}
		
		racProxy.publish('playbackSync', [playbackState]);
	}

	setTimeout(() => {
		syncPlaybackState();
	}, 5000);
}
syncPlaybackState();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", null, "playbackSessionId: " + _toDisplayString(playbackSessionId.value), 1),
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(videos, (videoInfo, videoName, index) => {
          return _createElementVNode("li", { key: index }, [
            _createElementVNode("a", {
              class: _normalizeClass({selected: videoInfo.recordingSessionId === selectedVideoRecordingSessionId.value}),
              href: "#",
              onClick: _withModifiers(($event: any) => (selectVideo(videoInfo.recordingSessionId)), ["prevent"])
            }, _toDisplayString(videoName) + " / " + _toDisplayString(videoInfo.recordingSessionId), 11, _hoisted_4),
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoInfo.bookmarks, (bookmark) => {
              return (_openBlock(), _createElementBlock("button", {
                onClick: ($event: any) => (seekTo(videoInfo.recordingSessionId, bookmark)),
                key: bookmark[0]*60+bookmark[1]
              }, _toDisplayString(bookmark[0]) + ":" + _toDisplayString(bookmark[1]), 9, _hoisted_6))
            }), 128))
          ])
        }), 64))
      ]),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedVideoRecordingSessionId).value = $event)),
          size: "45",
          onClick: selectInputVideoRecordingSessionIdText,
          ref_key: "elSelectedVideoRecordingSessionId",
          ref: elSelectedVideoRecordingSessionId
        }, null, 512), [
          [_vModelText, selectedVideoRecordingSessionId.value]
        ])
      ]),
      (selectedVideoRecordingSessionId.value !== null)
        ? (_openBlock(), _createElementBlock("video", {
            key: 0,
            ref_key: "elVideo",
            ref: elVideo,
            controls: "",
            src: _unref(selectedVideoUrl),
            onPlay: _cache[1] || (_cache[1] = ($event: any) => (onVideoPlay())),
            onPlaying: _cache[2] || (_cache[2] = ($event: any) => (onVideoPlaying())),
            onPause: _cache[3] || (_cache[3] = ($event: any) => (onVideoPause())),
            onEnded: _cache[4] || (_cache[4] = ($event: any) => (onVideoEnded())),
            onRatechange: _cache[5] || (_cache[5] = ($event: any) => (onVideoRateChange())),
            onSeeked: _cache[6] || (_cache[6] = ($event: any) => (onVideoSeeked())),
            onWaiting: _cache[7] || (_cache[7] = ($event: any) => (onVideoWaiting()))
          }, null, 40, _hoisted_7))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})